import { useCrudActions } from '@/common/view/useCrudActions';
import { chatService } from '@/services/chat';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        banTimeout: 0,
        minGameWin: 0
    });

    const validations = {
        banTimeout: { required, integer, minValue: minValue(1) },
        minGameWin: { required, integer, minValue: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: chatService.setting.get,
        onSuccess: ({ data }) => {
            model.isNew = true;
            model.banTimeout = data.banTimeout;
            model.minGameWin = data.minGameWin;
        },
        onError: () => {
            model.isNew = false;
            model.banTimeout = null;
            model.minGameWin = null;
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => chatService.setting.update(model.banTimeout, model.minGameWin),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: chatService.setting.remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
